import React from 'react'
import Navbar from '../../Navbar/Navbar'
import './faq.css'
import Footer from '../../Footer/Footer'

export default function faq() {
  return (
    <div>
      <Navbar />
      <div className='banner'>
        <div className="banner-content">
            <h1>CONTACT</h1>
            <p>
                HOME | SUPPORT | FAQ's
            </p>
        </div>
      </div>
      <div className="faq-container">
        <h2>FAQ's Fire</h2>
        <div className="q">
            <div className="left">
                Do we have a 20 loop fire panel including imported panels? Give the model number.
            </div>
            <div className="right" onClick={()=>{
                if(document.getElementsByClassName('ans')[0].style.animationName == 'hide'){
                    document.getElementsByClassName('ans')[0].style.animation = 'show 0.2s linear 1 forwards normal'
                }
                else{
                    document.getElementsByClassName('ans')[0].style.animation = 'hide 0.2s linear 1 forwards normal'
                }
            }}>
                <i class="fa-solid fa-plus"></i>
            </div>
        </div>
        <div className="ans">
            answer to the above questionnnn <br />
            asdasdaasdas <br />
            sdfdsfsdf <br />
            dsfsdfds <br />
            sdfdsf
        </div>
        
        <div style={{
            textAlign:'center',
        }}>
            <button style={{
                backgroundColor:'#6377B6',
                borderRadius:'15px',
                padding:'10px 20px',
                margin:'20px',
                color:'white',
                outline: 'none',
                cursor:'pointer',
                border:'none',
            }}> Read more </button>
        </div>
      </div>
      <Footer />
    </div>
  )
}
